import { AppDispatcher } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { UIHelper } from '../utils/UIHelper';
import { LengthDialogData, DialogData, VisibilityStore } from '../stores/VisibilityStore';
import { Overlay, PopupMenu } from '../constants/Enums';
import { GlobalHelper } from '../utils/GlobalHelper';
import { ProjectSettingsStoreState, ProjectSettingsStore } from '../stores/ProjectSettingsStore';
import { ActionHelper } from '../utils/ActionHelper';
import { Stats } from '../utils/Stats';

export abstract class VisibilityActions {
    public static showPriceInfo(value: boolean): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SHOW_PRICE_INFO,
            value
        });
    }

    public static setFullscreen(value: boolean): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_FULLSCREEN,
            value
        });
    }

    public static showDoneMessage(value: string, duration: number = 0): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_DONE_MESSAGE,
            value: value
        });
    }

    public static showInfoMessage(value: string, duration: number = 0): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_INFO_MESSAGE,
            value: value
        });
        if (duration > 0) {
            UIHelper.timeout(duration).then(() => {
                AppDispatcher.dispatch({
                    actionType: ActionConstants.SET_INFO_MESSAGE,
                    value: ''
                });
            });
        }
    }

    public static closeLengthDialog(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_LENGTHDIALOG,
            value: null
        });
    }

    public static setLengthDialog(value: LengthDialogData): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_LENGTHDIALOG,
            value: value
        });
    }

    public static changeOverlay(overlay: Overlay, data: unknown | null = null): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_OVERLAY,
            value: {overlay: overlay, data: data}
        });
    }

    public static setDialog(dialogData: DialogData): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_DIALOG,
            value: dialogData
        });
    }

    public static setPopupMenu(popupMenu: PopupMenu): void {
        GlobalHelper.stopActiveTool();
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_POPUPMENU,
            value: popupMenu
        });

        if (popupMenu === PopupMenu.FLOORPLAN_SETUP) {
            const state: ProjectSettingsStoreState = ProjectSettingsStore.getState();
            if (state.floorPlan != null) {
                // Should run in brackground -> do not await
                (async (): Promise<void> => {
                    try {
                        await ActionHelper.waitFor({
                            actionTypes: [ActionConstants.SET_POPUPMENU],
                            rejectActionTypes: [ActionConstants.RESET_PROJECT_RELATED_SETTINGS]
                        });
                    } catch (_) {
                        // ignore reject
                        return;
                    }

                    const newState: ProjectSettingsStoreState = ProjectSettingsStore.getState();
                    if (newState.floorPlan != null && state.floorPlan != null) {
                        if (state.floorPlan.opacity !== newState.floorPlan.opacity) {
                            Stats.sendEvent({
                                category: 'FloorPlan',
                                action: 'settingchange',
                                label: 'opacity'
                            });
                        }

                        if (state.floorPlan.colorReduction !== newState.floorPlan.colorReduction) {
                            Stats.sendEvent({
                                category: 'FloorPlan',
                                action: 'settingchange',
                                label: 'colorReduction'
                            });
                        }
                    }
                })();
            }
        }
    }

    public static hidePopupMenu(popupMenu: PopupMenu): void {
        if (VisibilityStore.getState().popupMenu === popupMenu) {
            AppDispatcher.dispatch({
                actionType: ActionConstants.SET_POPUPMENU,
                value: PopupMenu.NONE
            });
        }
    }

    public static closeDialog(): void {
        AppDispatcher.dispatch({
            actionType: ActionConstants.SET_DIALOG,
            value: null
        });
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/actions/VisibilityActions.ts